module.exports = "label {\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis; }\n\n.panel-heading {\n  background-color: lightgray; }\n\n:host ::ng-deep .record-id-invalid input {\n  border: 3px solid #ff000e; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/point-details/general/point-details.component.scss
// module id = ./src/app/shared/point-details/general/point-details.component.scss
// module chunks = main